type Country = {
  phoneCode: string;
};

const getCountryByPhoneNumber = (
  countries: Country[] = [],
  value: string = ''
): Country | undefined =>
  countries
    .sort((a, b) => (a.phoneCode.length < b.phoneCode.length ? 1 : -1))
    .find((i) => value.replace('+', '').startsWith(i.phoneCode));

export default getCountryByPhoneNumber;
